// import React, { useState, useRef, useEffect, use } from "react";
// import { Modal, Button, Steps, Icon, Row, Col, message } from "antd";

// import "./index.less";
// import ImagesForm from "./ImagesForm";
// import PriceForm from "./PriceForm";
// import PaymentForm from "./PaymentForm";
// import { platformApi } from "../../../../../api";

// const { Step } = Steps;

// const VehicleModal = ({
//   open,
//   close,
//   editable,
//   emitData,
//   data: Data,
//   selected,
//   manufacturer,
// }) => {
//   const validityRef = useRef();
//   const [data, setData] = useState({});
//   const [current, setCurrent] = useState(0);
//   const [Vehicle, setVehicle] = useState(null);
//   const [isChecked, setIsChecked] = useState(null);
//   const [viewCurrent, setViewCurrent] = useState(0); // For view mode steps

//   useEffect(() => {
//     if (open) {
//       if (Data) {
//         // console.log("Get Data", Data)
//         // Ensure payment details are properly structured
//         console.log("data", Data);

//         const vehicleData = {
//           ...Data,
//           paymentDetails: Data.paymentDetails || {
//             paymentType: "cash",
//             financerId: null,
//             downPayment: null,
//             financerTenure: { data: [] },
//           },
//         };
//         setData(vehicleData);
//         console.log("vehicleData", vehicleData);
//       }
//     }
//   }, [open]);

//   function selectInsurance(insuranceData) {
//     setIsChecked(insuranceData);
//   }

//   function selectVehicleId(priceData) {
//     setVehicle(priceData);
//   }

//   function handlePaymentDataChange(paymentData) {
//     // Update the data object with payment details
//     setData((prevData) => ({
//       ...prevData,
//       paymentDetails: paymentData,
//     }));
//   }

//   const clearFields = () => {
//     setData({});
//     setCurrent(0);
//     setViewCurrent(0);
//     close();
//   };

//   const handleSubmit = () => {
//     data.id = "";
//     emitData(data);
//     clearFields();
//   };

//   const modalFooter = [
//     <Button
//       key="back"
//       onClick={() => {
//         if (editable) {
//           if (current > 0) setCurrent(current - 1);
//           else clearFields();
//         } else {
//           if (viewCurrent > 0) setViewCurrent(viewCurrent - 1);
//           else clearFields();
//         }
//       }}
//     >
//       {editable
//         ? current < 2
//           ? "Cancel"
//           : "Back"
//         : viewCurrent < 1
//           ? "Close"
//           : "Back"}
//     </Button>,
//     editable && (
//       <Button
//         onClick={() => {
//           if (validityRef.current()) {

//             // 🚨 Validate insurance in Price step
//             if (current === 1) {
//               if (!isChecked || isChecked.length === 0) {
//                 message.error("Please Select Insurance Type!");
//                 return;
//               }
//             }

//             if (current < 2) {
//               setCurrent(current + 1);
//             } else {
//               handleSubmit();
//             }
//           }
//         }}
//         type="primary"
//       >
//         {current > 1 ? "Save" : "Next"}
//       </Button>
//     ),
//     !editable && viewCurrent < 1 && (
//       <Button onClick={() => setViewCurrent(viewCurrent + 1)} type="primary">
//         Next
//       </Button>
//     ),
//   ];

//   const Forms = [
//     {
//       title: "Model",
//       Component: (
//         <ImagesForm
//           manufacturers={manufacturer}
//           data={data}
//           validityRef={validityRef}
//           open={open}
//           selectedVehicles={selected}
//           onSelect={selectVehicleId}
//         />
//       ),
//     },
//     {
//       title: "Price",
//       Component: (
//         <PriceForm
//           validityRef={validityRef}
//           editable={editable}
//           open={open}
//           data={data}
//           selectedId={Vehicle}
//           isCheckedInsurance={selectInsurance}
//         />
//       ),
//     },
//     {
//       title: "Payment",
//       Component: (
//         <PaymentForm
//           validityRef={validityRef}
//           editable={editable}
//           open={open}
//           data={data}
//           onPaymentDataChange={handlePaymentDataChange}
//         />
//       ),
//     },
//   ];

//   const ViewForms = [
//     {
//       title: "Price",
//       Component: (
//         <PriceForm
//           data={data}
//           editable={editable}
//           validityRef={validityRef}
//           open={open}
//           selectedId={Vehicle}
//           isCheckedInsurance={selectInsurance}
//         />
//       ),
//     },
//     {
//       title: "Payment",
//       Component: (
//         <PaymentForm
//           validityRef={validityRef}
//           editable={editable}
//           open={open}
//           data={data}
//           onPaymentDataChange={handlePaymentDataChange}
//         />
//       ),
//     },
//   ];

//   return (
//     <Modal
//       title="Select Vehicle"
//       visible={open}
//       onCancel={clearFields}
//       wrapClassName="Vehicle-Select-Modal"
//       footer={modalFooter}
//     >
//       {editable ? (
//         <Col>
//           <Row type="flex" justify="center">
//             <Col span={12}>
//               <Steps size="small" current={current} type="navigation">
//                 {Forms.map((form, index) => (
//                   <Step
//                     key={index}
//                     icon={<Icon type="" />}
//                     title={form.title}
//                   />
//                 ))}
//               </Steps>
//             </Col>
//           </Row>
//           <Row>{Forms[current].Component}</Row>
//         </Col>
//       ) : (
//         <Col>
//           <Row type="flex" justify="center">
//             <Col span={8}>
//               <Steps size="small" current={viewCurrent} type="navigation">
//                 {ViewForms.map((form, index) => (
//                   <Step
//                     key={index}
//                     icon={<Icon type="" />}
//                     title={form.title}
//                   />
//                 ))}
//               </Steps>
//             </Col>
//           </Row>
//           <Row>{ViewForms[viewCurrent].Component}</Row>
//         </Col>
//       )}
//     </Modal>
//   );
// };

// export default VehicleModal;
import React, { useState, useRef, useEffect, use } from "react";
import { Modal, Button, Steps, Icon, Row, Col, message } from "antd";

import "./index.less";
import ImagesForm from "./ImagesForm";
import PriceForm from "./PriceForm";
import PaymentForm from "./PaymentForm";

const { Step } = Steps;

const VehicleModal = ({
  open,
  close,
  editable,
  emitData,
  data: Data,
  selected,
  manufacturer,
}) => {
  const validityRef = useRef();
  const [data, setData] = useState({});
  const [current, setCurrent] = useState(0);
  const [Vehicle, setVehicle] = useState(null);
  const [isChecked, setIsChecked] = useState(null);
  const [viewCurrent, setViewCurrent] = useState(0); // For view mode steps
  const [vehicleTotal, setVehicleTotal] = useState(0); // ✅ ADD THIS STATE for total price

  useEffect(() => {
    if (open) {
      if (Data) {
        const vehicleData = {
          ...Data,
          paymentDetails: Data.paymentDetails || {
            paymentType: "cash",
            financerId: null,
            downPayment: null,
            financerTenure: { data: [] },
          },
        };
        setData(vehicleData);
      }
    }
  }, [open]);

  function selectInsurance(insuranceData) {
    setIsChecked(insuranceData);
  }

  function selectVehicleId(priceData) {
    setVehicle(priceData);
  }

  // ✅ ADD THIS FUNCTION to receive total from PriceForm
  const handleTotalChange = (total) => {
    console.log("Vehicle total updated:", total);
    setVehicleTotal(total);
  };

  function handlePaymentDataChange(paymentData) {
    // Update the data object with payment details
    setData((prevData) => ({
      ...prevData,
      paymentDetails: paymentData,
    }));
  }

  const clearFields = () => {
    setData({});
    setCurrent(0);
    setViewCurrent(0);
    setVehicleTotal(0); // ✅ Reset total
    close();
  };

  const handleSubmit = () => {
    data.id = "";
    emitData(data);
    clearFields();
  };

  const modalFooter = [
    <Button
      key="back"
      onClick={() => {
        if (editable) {
          if (current > 0) setCurrent(current - 1);
          else clearFields();
        } else {
          if (viewCurrent > 0) setViewCurrent(viewCurrent - 1);
          else clearFields();
        }
      }}
    >
      {editable
        ? current < 2
          ? "Cancel"
          : "Back"
        : viewCurrent < 1
          ? "Close"
          : "Back"}
    </Button>,
    editable && (
      <Button
        onClick={() => {
          if (validityRef.current()) {

            // 🚨 Validate insurance in Price step
            if (current === 1) {
              if (!isChecked || isChecked.length === 0) {
                message.error("Please Select Insurance Type!");
                return;
              }
            }

            if (current < 2) {
              setCurrent(current + 1);
            } else {
              handleSubmit();
            }
          }
        }}
        type="primary"
      >
        {current > 1 ? "Save" : "Next"}
      </Button>
    ),
    !editable && viewCurrent < 1 && (
      <Button onClick={() => setViewCurrent(viewCurrent + 1)} type="primary">
        Next
      </Button>
    ),
  ];

  const Forms = [
    {
      title: "Model",
      Component: (
        <ImagesForm
          manufacturers={manufacturer}
          data={data}
          validityRef={validityRef}
          open={open}
          selectedVehicles={selected}
          onSelect={selectVehicleId}
        />
      ),
    },
    {
      title: "Price",
      Component: (
        <PriceForm
          validityRef={validityRef}
          editable={editable}
          open={open}
          data={data}
          selectedId={Vehicle}
          isCheckedInsurance={selectInsurance}
          onTotalChange={handleTotalChange} // ✅ ADD THIS PROP
        />
      ),
    },
    {
      title: "Payment",
      Component: (
        <PaymentForm
          validityRef={validityRef}
          editable={editable}
          open={open}
          data={data}
          onPaymentDataChange={handlePaymentDataChange}
          vehicleTotal={vehicleTotal} // ✅ ADD THIS PROP
        />
      ),
    },
  ];

  const ViewForms = [
    {
      title: "Price",
      Component: (
        <PriceForm
          data={data}
          editable={editable}
          validityRef={validityRef}
          open={open}
          selectedId={Vehicle}
          isCheckedInsurance={selectInsurance}
          onTotalChange={handleTotalChange} // ✅ ADD THIS PROP for view mode too
        />
      ),
    },
    {
      title: "Payment",
      Component: (
        <PaymentForm
          validityRef={validityRef}
          editable={editable}
          open={open}
          data={data}
          onPaymentDataChange={handlePaymentDataChange}
          vehicleTotal={vehicleTotal} // ✅ ADD THIS PROP for view mode too
        />
      ),
    },
  ];

  return (
    <Modal
      title="Select Vehicle"
      visible={open}
      onCancel={clearFields}
      wrapClassName="Vehicle-Select-Modal"
      footer={modalFooter}
    >
      {editable ? (
        <Col>
          <Row type="flex" justify="center">
            <Col span={12}>
              <Steps size="small" current={current} type="navigation">
                {Forms.map((form, index) => (
                  <Step
                    key={index}
                    icon={<Icon type="" />}
                    title={form.title}
                  />
                ))}
              </Steps>
            </Col>
          </Row>
          <Row>{Forms[current].Component}</Row>
        </Col>
      ) : (
        <Col>
          <Row type="flex" justify="center">
            <Col span={8}>
              <Steps size="small" current={viewCurrent} type="navigation">
                {ViewForms.map((form, index) => (
                  <Step
                    key={index}
                    icon={<Icon type="" />}
                    title={form.title}
                  />
                ))}
              </Steps>
            </Col>
          </Row>
          <Row>{ViewForms[viewCurrent].Component}</Row>
        </Col>
      )}
    </Modal>
  );
};

export default VehicleModal;